var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.294 3.82353C2.294 1.71185 4.00585 0 6.11753 0C8.22921 0 9.94106 1.71185 9.94106 3.82353V5.353H10.2353C11.3399 5.353 12.2353 6.24843 12.2353 7.353V11.0001C12.2353 12.1046 11.3399 13.0001 10.2353 13.0001H2C0.895431 13.0001 0 12.1046 0 11.0001V7.353C0 6.24843 0.895431 5.353 2 5.353H2.294V3.82353ZM6.11745 1.52933C4.85044 1.52933 3.82333 2.55644 3.82333 3.82345V5.35286H8.41157V3.82345C8.41157 2.55644 7.38445 1.52933 6.11745 1.52933Z",
    fill: "#00A4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4e79d064366002a1cbb9670d37444352.svg";
export { ForwardRef as ReactComponent };